"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useGetProductByProductCodeServerQueryOptions = exports.getProductByProductCodeServer = exports.useGetProductByProductCodeQueryOptions = exports.useGetProductByProductCodeHook = exports.useGetProductFeaturesComparisonServerQueryOptions = exports.getProductFeaturesComparisonServer = exports.useGetProductFeaturesComparisonQueryOptions = exports.useGetProductFeaturesComparisonHook = void 0;
exports.useGetProductFeaturesComparison = useGetProductFeaturesComparison;
exports.useGetProductFeaturesComparisonServer = useGetProductFeaturesComparisonServer;
exports.useGetProductByProductCode = useGetProductByProductCode;
exports.useGetProductByProductCodeServer = useGetProductByProductCodeServer;
/* eslint-disable @typescript-eslint/no-unused-vars */
/**
 * Generated by orval v7.6.0 🍺
 * Do not edit manually.
 * OpenAPI definition
 * OpenAPI spec version: v0
 */
const react_query_1 = require("@tanstack/react-query");
const react_1 = require("react");
const useQueryFetch_1 = require("../../utils/orval/useQueryFetch");
const queryFetch_1 = require("../../utils/orval/queryFetch");
const queryKeyMutator_1 = require("../../utils/orval/queryKeyMutator");
const useGetProductFeaturesComparisonHook = () => {
    const getProductFeaturesComparison = (0, useQueryFetch_1.useQueryFetch)();
    return (0, react_1.useCallback)((market, mainWebShopId, productId, params, operationName = 'getProductFeaturesComparison', options, signal) => {
        return getProductFeaturesComparison({
            url: `/api/aem/product/features/comparison/${market}/${mainWebShopId}/${productId}`,
            method: 'GET',
            params,
            signal,
        }, Object.assign({ operationName: 'getProductFeaturesComparison' }, options));
    }, [getProductFeaturesComparison]);
};
exports.useGetProductFeaturesComparisonHook = useGetProductFeaturesComparisonHook;
const useGetProductFeaturesComparisonQueryOptions = (market, mainWebShopId, productId, params, operationName = 'getProductFeaturesComparison', options) => {
    const { query: queryOptions, request: requestOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (0, queryKeyMutator_1.queryKeyMutator)({ market, mainWebShopId, productId, params, operationName }, { url: `/api/aem/product/features/comparison/${market}/${mainWebShopId}/${productId}`, queryOptions });
    const getProductFeaturesComparison = (0, exports.useGetProductFeaturesComparisonHook)();
    const queryFn = ({ signal, }) => getProductFeaturesComparison(market, mainWebShopId, productId, params, operationName, requestOptions, signal);
    return Object.assign({ queryKey, queryFn, enabled: !!(market && mainWebShopId && productId) }, queryOptions);
};
exports.useGetProductFeaturesComparisonQueryOptions = useGetProductFeaturesComparisonQueryOptions;
function useGetProductFeaturesComparison(market, mainWebShopId, productId, params, operationName = 'getProductFeaturesComparison', options) {
    const queryOptions = (0, exports.useGetProductFeaturesComparisonQueryOptions)(market, mainWebShopId, productId, params, operationName, options);
    const query = (0, react_query_1.useQuery)(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
const getProductFeaturesComparisonServer = (market, mainWebShopId, productId, params, operationName = 'getProductFeaturesComparison', options, signal) => {
    return (0, queryFetch_1.queryFetch)({
        url: `/public/cache/product/features/comparison/${market}/${mainWebShopId}/${productId}`,
        method: 'GET',
        params,
        signal,
    }, Object.assign({ operationName: 'getProductFeaturesComparison' }, options));
};
exports.getProductFeaturesComparisonServer = getProductFeaturesComparisonServer;
const useGetProductFeaturesComparisonServerQueryOptions = (market, mainWebShopId, productId, params, operationName = 'getProductFeaturesComparison', options) => {
    const { query: queryOptions, request: requestOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (0, queryKeyMutator_1.queryKeyMutator)({ market, mainWebShopId, productId, params, operationName }, { url: `/public/cache/product/features/comparison/${market}/${mainWebShopId}/${productId}`, queryOptions });
    const queryFn = ({ signal }) => (0, exports.getProductFeaturesComparisonServer)(market, mainWebShopId, productId, params, operationName, requestOptions, signal);
    return Object.assign({ queryKey, queryFn, enabled: !!(market && mainWebShopId && productId) }, queryOptions);
};
exports.useGetProductFeaturesComparisonServerQueryOptions = useGetProductFeaturesComparisonServerQueryOptions;
function useGetProductFeaturesComparisonServer(market, mainWebShopId, productId, params, operationName = 'getProductFeaturesComparison', options) {
    const queryOptions = (0, exports.useGetProductFeaturesComparisonServerQueryOptions)(market, mainWebShopId, productId, params, operationName, options);
    const query = (0, react_query_1.useQuery)(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
const useGetProductByProductCodeHook = () => {
    const getProductByProductCode = (0, useQueryFetch_1.useQueryFetch)();
    return (0, react_1.useCallback)((params, operationName = 'getProductByProductCode', options, signal) => {
        return getProductByProductCode({ url: `/api/aem/product/productcode`, method: 'GET', params, signal }, Object.assign({ operationName: 'getProductByProductCode' }, options));
    }, [getProductByProductCode]);
};
exports.useGetProductByProductCodeHook = useGetProductByProductCodeHook;
const useGetProductByProductCodeQueryOptions = (params, operationName = 'getProductByProductCode', options) => {
    const { query: queryOptions, request: requestOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (0, queryKeyMutator_1.queryKeyMutator)({ params, operationName }, { url: `/api/aem/product/productcode`, queryOptions });
    const getProductByProductCode = (0, exports.useGetProductByProductCodeHook)();
    const queryFn = ({ signal }) => getProductByProductCode(params, operationName, requestOptions, signal);
    return Object.assign({ queryKey, queryFn }, queryOptions);
};
exports.useGetProductByProductCodeQueryOptions = useGetProductByProductCodeQueryOptions;
function useGetProductByProductCode(params, operationName = 'getProductByProductCode', options) {
    const queryOptions = (0, exports.useGetProductByProductCodeQueryOptions)(params, operationName, options);
    const query = (0, react_query_1.useQuery)(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
const getProductByProductCodeServer = (params, operationName = 'getProductByProductCode', options, signal) => {
    return (0, queryFetch_1.queryFetch)({ url: `/enrichedproduct/productcode`, method: 'GET', params, signal }, Object.assign({ operationName: 'getProductByProductCode' }, options));
};
exports.getProductByProductCodeServer = getProductByProductCodeServer;
const useGetProductByProductCodeServerQueryOptions = (params, operationName = 'getProductByProductCode', options) => {
    const { query: queryOptions, request: requestOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (0, queryKeyMutator_1.queryKeyMutator)({ params, operationName }, { url: `/enrichedproduct/productcode`, queryOptions });
    const queryFn = ({ signal }) => (0, exports.getProductByProductCodeServer)(params, operationName, requestOptions, signal);
    return Object.assign({ queryKey, queryFn }, queryOptions);
};
exports.useGetProductByProductCodeServerQueryOptions = useGetProductByProductCodeServerQueryOptions;
function useGetProductByProductCodeServer(params, operationName = 'getProductByProductCode', options) {
    const queryOptions = (0, exports.useGetProductByProductCodeServerQueryOptions)(params, operationName, options);
    const query = (0, react_query_1.useQuery)(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
//# sourceMappingURL=product-service.js.map